import React, { useEffect, useRef, useState } from 'react';
import TableDocuments from '../ClinicComponent/TableDocuments';
import Swal from 'sweetalert2';
import { validarInputExpresionRegular } from '../../utils/generalFunctions';
import { alertaCargandoProceso, alertaGeneral } from '../../utils/alertas';
import CompleterProfileDoctor from './CompleteProfileDoctor';
import CompleteProfileExpert from './CompleteProfileExpert';
import ReenvioDocumentos from './ReenvioDocumentos';
import apiClient from '../../utils/axiosPetition';
import Cargando from '../../utils/Cargando';
import UserProfile from '../AdminComponent/UserProfile';
import RedesSociales from '../PatientComponent/RedesSociales';
import { useLocation } from 'react-router-dom';
import { useDataUser } from '../../context/dataUserContext';
import { useMembership } from '../../context/MembershipContext';
import PatientProfile from '../PatientComponent/PatientProfile';
import SignatureCanvas from 'react-signature-canvas';
import ContratoVinculacionPlanMiembroPremium from './ContratoVinculacionPlanMiembroPremium';
import { SignatureHelpModal, SignatureInstructionsPanel } from './SignatureHelp';
import Modal from 'react-modal';
import { formatServiceName } from '../../utils/formatServiceName';
Modal.setAppElement('#root');

const DoctorInfo = () => {
    const { patientId, doctorId, setFullName } = useDataUser();
    const { membershipStatus, loading: membershipLoading } = useMembership();

    const location = useLocation();
    const [doctor, setDoctor] = useState({});
    const [activeTab, setActiveTab] = useState('doctor');

    const [file, setFile] = useState({
        foto_perfil: null,
        cedulaPDF: null,
        diploma_acta_grado: null,
        homologacion_estudios: null,
        diploma_especializacion: null,
        tarjeta_profesional: null,
        firma_profesional: null,
        rethus: null,
        poliza_responsabilidad_civil: null,
    });

    const [showConfirmPhotoModal, setShowConfirmPhotoModal] = useState(false);
    const [previewPhoto, setPreviewPhoto] = useState(null);
    const [showConfirmPriceModal, setShowConfirmPriceModal] = useState(false);
    const [pendingPrice, setPendingPrice] = useState(null);

    // Debug: Verificar cuando file.foto_perfil cambia
    useEffect(() => {
        console.log('Estado file.foto_perfil actualizado:', file.foto_perfil);
        if (file?.foto_perfil) {
            // Crear URL de vista previa
            const photoUrl = URL.createObjectURL(file.foto_perfil);
            setPreviewPhoto(photoUrl);
            setShowConfirmPhotoModal(true);
        } else {
            setShowConfirmPhotoModal(false);
            if (previewPhoto) {
                URL.revokeObjectURL(previewPhoto);
                setPreviewPhoto(null);
            }
        }
    }, [file.foto_perfil]);

    // Limpiar URL de vista previa al desmontar
    useEffect(() => {
        return () => {
            if (previewPhoto) {
                URL.revokeObjectURL(previewPhoto);
            }
        };
    }, [previewPhoto]);

    const [showCompleteProfile, setShowCompleteProfile] = useState(location.state?.showCompleteProfile || false);
    const [profileRoute, setProfileRoute] = useState(
        location.state?.profileRoute || (location.state?.showCompleteProfile ? 'asistencial' : null)
    );
    const [welcomeChoice, setWelcomeChoice] = useState(null);

    const iniciarPrestacionServicios = () => {
        setProfileRoute('asistencial');
        setShowCompleteProfile(true);
    };

    useEffect(() => {
        if (location.state?.activarPrestacionServicios) {
            iniciarPrestacionServicios();
            window.history.replaceState({}, document.title);
        }
    }, [location.state?.activarPrestacionServicios]);
    const [showReenvioDocumentos, setShowReenvioDocumentos] = useState(false);
    const [showRestrictionMessage, setShowRestrictionMessage] = useState(false);
    const [showPremiumContractModal, setShowPremiumContractModal] = useState(false);
    const [showFirmaInstruccionesModal, setShowFirmaInstruccionesModal] = useState(false);
    const [premiumContractSigning, setPremiumContractSigning] = useState(false);
    const [cargando, setCargando] = useState(true);
    const [inputsDoctor, setInputsDoctor] = useState(null);
    const [textareasDoctor, setTextareasDoctor] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [tieneHorariosConfigurados, setTieneHorariosConfigurados] = useState(false);
    const [verificandoHorarios, setVerificandoHorarios] = useState(true);
    const [dataOriginal, setDataOriginal] = useState({
        fullName: '',
        description: '',
        cellNumber: '',
        email: '',
        priceService: '',
        preciosCitas: {
            teleconsultaPrimeraVez: 0,
            precioControles: 60000,
            precioTeleorientacion: 25000,
        },
    });
    const sigCanvasRefPremiumContrato = useRef(null);
    const signatureContainerRefPremiumContrato = useRef(null);
    const [signatureCanvasSizePremiumContrato, setSignatureCanvasSizePremiumContrato] = useState({ width: 500, height: 160 });
    const [premiumContractModalNombre, setPremiumContractModalNombre] = useState('');
    const [premiumContractModalIdType, setPremiumContractModalIdType] = useState('');
    const [premiumContractModalIdNumber, setPremiumContractModalIdNumber] = useState('');
    const isPremiumDoctor = membershipStatus?.plan === 'premium';
    const hasPremiumContractSigned = !!doctor?.urlContratoVinculacionPremiumFirmado;

    useEffect(() => {
        if (showPremiumContractModal) {
            setPremiumContractModalNombre(doctor?.fullName || '');
            setPremiumContractModalIdType(doctor?.idType || '');
            setPremiumContractModalIdNumber(doctor?.idNumber || '');
            setShowFirmaInstruccionesModal(true);
        } else {
            setShowFirmaInstruccionesModal(false);
        }
    }, [showPremiumContractModal, doctor?.fullName, doctor?.idType, doctor?.idNumber]);

    useEffect(() => {
        if (!showPremiumContractModal) return;
        const updateSize = () => {
            if (signatureContainerRefPremiumContrato.current) {
                const w = signatureContainerRefPremiumContrato.current.clientWidth || 500;
                setSignatureCanvasSizePremiumContrato({ width: Math.max(280, Math.floor(w)), height: 160 });
            }
        };
        updateSize();
        const t1 = setTimeout(updateSize, 50);
        const t2 = setTimeout(updateSize, 250);
        window.addEventListener('resize', updateSize);
        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
            window.removeEventListener('resize', updateSize);
        };
    }, [showPremiumContractModal]);

    useEffect(() => {
        apiClient(`/api/doctor/${doctorId}`)
            .then((response) => {
                const doctorData = response.data;
                console.log('Doctor data recibida:', doctorData);
                console.log('Service:', doctorData.service);
                console.log('PreciosCitas recibidos:', doctorData.preciosCitas);
                
                // Inicializar preciosCitas si no existen
                if (!doctorData.preciosCitas) {
                    doctorData.preciosCitas = {
                        teleconsultaPrimeraVez: 0,
                        precioControles: 60000,
                        precioTeleorientacion: 25000,
                    };
                }
                setDoctor(doctorData);
                setCargando(false);
                setDataOriginal({
                    fullName: doctorData.fullName,
                    description: doctorData.description,
                    cellNumber: doctorData.cellNumber,
                    email: doctorData.email,
                    priceService: doctorData.priceService,
                    preciosCitas: doctorData.preciosCitas,
                });
                
                // Verificar si tiene horarios configurados
                const esExperto =
                    doctorData.tipoPerfil === 'experto' ||
                    (doctorData.estado === 'aprobado' && doctorData.prestacionServicio === false);
                if (doctorData.estado === 'aprobado' && !esExperto) {
                    verificarHorariosConfigurados(doctorData._id);
                } else {
                    setVerificandoHorarios(false);
                }
            })
            .catch((error) => {
                alertaGeneral({
                    titulo: 'Error',
                    messageHtml: error.response?.data?.message || 'No se pudo obtener la información del doctor, intente nuevamente.',
                    isError: true,
                })
                setCargando(false);
                setVerificandoHorarios(false);
            })
    }, []);
    
    // Función para verificar si el doctor tiene horarios configurados
    const verificarHorariosConfigurados = async (doctorId) => {
        try {
            const response = await apiClient.get(`/api/doctor/horarios/${doctorId}`);
            const tieneHorarios = response.data.horarios && response.data.horarios.length > 0;
            setTieneHorariosConfigurados(tieneHorarios);
            setVerificandoHorarios(false);
        } catch (error) {
            console.error('Error al verificar horarios:', error);
            setTieneHorariosConfigurados(false);
            setVerificandoHorarios(false);
        }
    };

    const dataURLtoFile = (dataurl, filename) => {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) u8arr[n] = bstr.charCodeAt(n);
        return new File([u8arr], filename, { type: mime });
    };

    const handleFirmarContratoPremium = async () => {
        if (!sigCanvasRefPremiumContrato.current) return;
        if (sigCanvasRefPremiumContrato.current.isEmpty()) {
            alertaGeneral({
                titulo: 'Firma requerida',
                messageHtml: 'Debes dibujar tu firma en el recuadro antes de enviar.',
                isWarning: true
            });
            return;
        }

        const nombreTrim = (premiumContractModalNombre || '').trim();
        const idNumTrim = (premiumContractModalIdNumber || '').trim();

        if (!nombreTrim) {
            alertaGeneral({ titulo: 'Datos requeridos', messageHtml: 'Ingresa tu nombre completo en el formulario del contrato.', isError: true });
            return;
        }
        if (!idNumTrim) {
            alertaGeneral({ titulo: 'Datos requeridos', messageHtml: 'Indique su número de identificación en el modal del contrato.', isError: true });
            return;
        }

        setPremiumContractSigning(true);
        try {
            const dataUrl = sigCanvasRefPremiumContrato.current.toDataURL('image/png');
            const file = dataURLtoFile(dataUrl, 'firma-contrato-premium.png');
            const formData = new FormData();
            formData.append('signature', file);
            formData.append('nombre', nombreTrim);
            formData.append('idType', (premiumContractModalIdType || '').trim());
            formData.append('idNumber', idNumTrim);
            formData.append('contractType', 'premium');

            const res = await apiClient.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/doctor/${doctor._id}/firmar-contrato-vinculacion`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (res.data?.doctor) {
                setDoctor(res.data.doctor);
            }

            setShowPremiumContractModal(false);
            alertaGeneral({
                titulo: '¡Tu contrato ha sido firmado!',
                messageHtml: 'Puedes continuar con el siguiente paso para completar tu perfil.',
                confirmButtonText: 'Continuar'
            });
        } catch (err) {
            alertaGeneral({
                titulo: 'Error al firmar',
                messageHtml: err?.response?.data?.message || 'No se pudo guardar la firma. Intente de nuevo.',
                isError: true
            });
        } finally {
            setPremiumContractSigning(false);
        }
    };

    useEffect(() => {
        if (doctor) {
            setTextareasDoctor([
                {
                    label: 'Descripción',
                    value: doctor.description,
                    readOnly: !isEdit,
                    onChange: (ev) => { setDoctor({ ...doctor, description: ev.target.value }) }
                }
            ]);
            setInputsDoctor([
                {
                    label: 'Nombres Completos',
                    type: 'text',
                    value: doctor.fullName,
                    readOnly: !isEdit,
                    onChange: (ev) => { setDoctor({ ...doctor, fullName: ev.target.value }) }
                },
                {
                    label: 'Tipo de Identifiación',
                    type: 'text',
                    value: doctor.idType?.toUpperCase(),
                    readOnly: true,
                },
                {
                    label: 'Número de Identificación',
                    type: 'text',
                    value: doctor.idNumber,
                    readOnly: true
                },
                {
                    label: 'Correo Electrónico',
                    type: 'email',
                    value: doctor.email,
                    readOnly: !isEdit,
                    onChange: (ev) => { setDoctor({ ...doctor, email: ev.target.value }) }
                },
                {
                    label: 'Número de Celular',
                    type: 'text',
                    value: doctor.cellNumber,
                    readOnly: !isEdit,
                    onChange: (ev) => { setDoctor({ ...doctor, cellNumber: validarInputExpresionRegular(ev, /[^0-9]/g) }) }
                },
                {
                    label: 'Servicio',
                    type: 'text',
                    value: formatServiceName(doctor.service),
                    readOnly: true
                },
            ]);
        }
    }, [doctor, isEdit]);

    useEffect(() => {
        if (!isEdit) {
            // Preservar el campo service cuando se cancela la edición
            const serviceToPreserve = doctor.service;
            setDoctor({ ...doctor, ...dataOriginal, service: serviceToPreserve || doctor.service });
        }
    }, [isEdit]);

    // Ocultar el letrero cuando se cambia a la pestaña de doctor
    useEffect(() => {
        if (activeTab === 'doctor') {
            setShowRestrictionMessage(false);
        }
    }, [activeTab]);

    // Debug: Verificar cuando el doctor cambia
    useEffect(() => {
        if (doctor && Object.keys(doctor).length > 0) {
            console.log('Doctor actualizado:', {
                service: doctor.service,
                preciosCitas: doctor.preciosCitas,
                isNutricionista: isNutricionista()
            });
        }
    }, [doctor]);

    const docsBase = [
        { nameToSave: 'cedulaPDF', name: 'Documento Identidad', url: doctor?.urlIdDocument || '', isEdit: true },
        { nameToSave: 'diploma_acta_grado', name: 'Diploma Grado', url: doctor?.urlUndergraduateDiploma || '', isEdit: true },
        { nameToSave: 'homologacion_estudios', name: 'Homologación Estudios', url: doctor?.urlStudyHomologation || '', isEdit: true },
        { nameToSave: 'diploma_especializacion', name: 'Diploma Especialización', url: doctor?.urlSpecializationDiploma || '', isEdit: true },
        { nameToSave: 'tarjeta_profesional', name: 'Tarjeta Profesional', url: doctor?.urlProfessionalCard || '', isEdit: true },
        { nameToSave: 'firma_profesional', name: 'Firma Profesional', url: doctor?.urlProfessionalSignature || '', isEdit: true },
        { nameToSave: 'rethus', name: 'Certificado Rethus', url: doctor?.urlRethusDocument || '', isEdit: true },
        { nameToSave: 'poliza_responsabilidad_civil', name: 'Poliza Responsabilidad Civil', url: doctor?.urlCivilLiabilityPolicyDocument || '', isEdit: true },
    ];
    const documentsApprovedMap = (doctor?.documentsApproved || []).reduce((acc, d) => {
        if (d && d.document) acc[d.document] = { isApproved: d.isApproved, rejectionReason: d.rejectionReason || '' };
        return acc;
    }, {});
    const documentsExists = docsBase.map(doc => {
        const status = documentsApprovedMap[doc.nameToSave];
        return {
            ...doc,
            isApproved: status?.isApproved,
            rejectionReason: status?.rejectionReason || '',
            isEdit: status?.isApproved !== true, // Los aprobados no se pueden editar
        };
    });

    const hasDocumentosParaGuardar = documentsExists.some(d => d.nameToSave && file[d.nameToSave] instanceof File);

    const onGuardarDocumentosAlmacenados = () => {
        const documentosAEnviar = documentsExists.filter(d => d.nameToSave && file[d.nameToSave] instanceof File);
        if (documentosAEnviar.length === 0) return;
        alertaCargandoProceso({
            titulo: 'Guardando documentos',
            messageHtml: 'Actualizando los documentos seleccionados...',
            funcionAsync: async () => {
                try {
                    let doctorActualizado = { ...doctor };
                    for (const doc of documentosAEnviar) {
                        const formData = new FormData();
                        formData.append(doc.nameToSave, file[doc.nameToSave]);
                        const res = await apiClient.put(`/api/afiliado/actualizar-documento/${doctor._id}`, formData);
                        if (res.data?.doctor) doctorActualizado = res.data.doctor;
                    }
                    setDoctor(doctorActualizado);
                    setFile(prev => {
                        const next = { ...prev };
                        documentosAEnviar.forEach(d => { next[d.nameToSave] = null; });
                        return next;
                    });
                    Swal.close();
                    alertaGeneral({ titulo: 'Documentos actualizados', messageHtml: 'Los documentos se han guardado correctamente.' });
                } catch (err) {
                    Swal.close();
                    alertaGeneral({
                        titulo: 'Error',
                        messageHtml: err.response?.data?.message || 'No se pudieron guardar algunos documentos. Intenta de nuevo.',
                        isError: true
                    });
                }
            }
        });
    };

    const onHandleSubmitFiles = () => {
        if (!file.foto_perfil) {
            alertaGeneral({
                titulo: 'Error',
                messageHtml: 'No hay foto seleccionada para actualizar.',
                isError: true
            });
            return;
        }

        const dataDoctorToSend = new FormData();

        dataDoctorToSend.append('foto_perfil', file.foto_perfil);
        dataDoctorToSend.append('clinicInfo', doctor.clinicInfo._id);
        dataDoctorToSend.append('idNumber', doctor.idNumber);

        apiClient.put(`/api/doctor/updatePictureProfile/${doctor._id}`, dataDoctorToSend)
            .then((res) => {
                if (res.status === 200) {
                    // Limpiar el estado de la foto
                    setFile(prevFile => ({ ...prevFile, foto_perfil: null }));
                    if (previewPhoto) {
                        URL.revokeObjectURL(previewPhoto);
                        setPreviewPhoto(null);
                    }
                    setShowConfirmPhotoModal(false);
                    
                    Swal.fire({
                        icon: 'success',
                        title: 'Foto actualizada correctamente',
                        text: 'La foto del doctor ha sido actualizada correctamente.',
                    }).then(() => {
                        localStorage.setItem('imageProfile', res.data);
                        window.location.reload();
                    })
                }
            })
            .catch((error) => {
                alertaGeneral({
                    titulo: 'Error',
                    messageHtml: error.response?.data?.message || 'No se pudo actualizar la foto de perfil, intente nuevamente.',
                    isError: true
                })
            })
    }

    // Función para verificar si el doctor es nutricionista
    const isNutricionista = () => {
        if (!doctor) {
            console.log('isNutricionista: No hay doctor');
            return false;
        }
        if (!doctor.service) {
            console.log('isNutricionista: No hay service en doctor:', doctor);
            return false;
        }
        
        const service = doctor.service;
        if (!service) {
            console.log('isNutricionista: service es undefined o vacío');
            return false;
        }
        
        const serviceLower = service.toLowerCase();
        
        // Normalizar para comparar sin tildes (nutrición -> nutricion)
        const normalizeString = (str) => {
            return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        };
        
        const serviceNormalized = normalizeString(service);
        
        // Verificar todas las variaciones posibles (sin tildes para comparación)
        const variaciones = [
            'nutricion',
            'nutricionista',
            'nutricionistas'
        ];
        
        // Limpiar el servicio: quitar números y guiones bajos
        const serviceClean = serviceNormalized.replace(/\d+/g, '').replace(/_/g, ' ').replace(/-/g, ' ').trim();
        
        // Verificar si contiene alguna variación
        const isNutri = variaciones.some(variacion => 
            serviceNormalized === variacion || 
            serviceNormalized.includes(variacion) ||
            serviceClean.includes(variacion)
        );
        
        console.log('isNutricionista check:', { 
            service: service, 
            serviceLower: serviceLower,
            serviceNormalized: serviceNormalized,
            serviceClean: serviceClean, 
            isNutri: isNutri,
            preciosCitas: doctor.preciosCitas
        });
        
        return isNutri;
    }

    const onHandleActualizarPerfil = () => {
        const fullNameTrimmed = doctor.fullName?.trim();
        if (!fullNameTrimmed) {
            alertaGeneral({
                titulo: 'Error de validación',
                messageHtml: 'El nombre completo es obligatorio.',
                isError: true
            });
            return;
        }

        const dataDoctor = {
            fullName: fullNameTrimmed,
            description: doctor.description,
            cellNumber: doctor.cellNumber,
            email: doctor.email?.toLowerCase(),
            priceService: doctor.priceService,
            service: doctor.service, // Preservar el servicio
        };

        alertaCargandoProceso({
            titulo: "Actualizando información...",
            isTransparent: false,
            funcionAsync: () => {
                apiClient.put(`/api/clinic/editDoctor/${doctor._id}`, dataDoctor)
                    .then((res) => {
                        if (res.status === 200) {
                            if (res.data.fullName && setFullName) setFullName(res.data.fullName);
                            alertaGeneral({ titulo: "Cambios realizados", messageHtml: "Los cambios se han realizado correctamente." });
                            setDataOriginal({
                                fullName: res.data.fullName,
                                description: res.data.description,
                                cellNumber: res.data.cellNumber,
                                email: res.data.email?.toLowerCase(),
                                priceService: res.data.priceService,
                                preciosCitas: res.data.preciosCitas || {
                                    teleconsultaPrimeraVez: 0,
                                    precioControles: 60000,
                                    precioTeleorientacion: 25000,
                                },
                            });
                            setDoctor(res.data);
                            setIsEdit(false);
                        }
                    })
                    .catch((error) => {
                        alertaGeneral({
                            titulo: "Error al actualizar",
                            messageHtml: "Error inesperado, por favor intenta de nuevo.",
                            isError: true
                        });
                        setIsEdit(false);
                    });
            }
        })
    }


    const onEditCancel = () => {
        setIsEdit(!isEdit);
    }

    // Función para verificar si el doctor puede acceder al perfil de usuario
    const handlePatientTabClick = () => {
        // Verificar si el perfil del doctor está incompleto
        if (doctor.estado === 'no_aprobado') {
            // Cambiar a la pestaña de paciente y mostrar el letrero de restricción
            setActiveTab('patient');
            setShowRestrictionMessage(true);
            setIsEdit(false);
            return;
        }
        // Si el perfil está completo, permitir el cambio de pestaña
        setShowRestrictionMessage(false);
        setActiveTab('patient');
        setIsEdit(false);
    }

    if (cargando) {
        return (
            <Cargando message={"Cargando perfil del doctor..."} />
        );
    }

    // Verificar si es nutricionista una vez que el doctor esté cargado
    const esNutricionista = doctor && Object.keys(doctor).length > 0 && doctor.service ? isNutricionista() : false;
    console.log('Render completo - esNutricionista:', esNutricionista, 'doctor.service:', doctor?.service, 'doctor tiene datos:', doctor && Object.keys(doctor).length > 0);

    // Si el doctor es nuevo (no aprobado y sin prestación de servicio), mostrar SOLO la sección de prestar servicio
    const esUsuarioNuevo = doctor.estado === 'no_aprobado';
    const puedeActivarPrestacionServicios =
        !esUsuarioNuevo &&
        doctor.tipoPerfil === 'experto' &&
        !doctor.prestacionServicio;

    return !showCompleteProfile && !showReenvioDocumentos ? (
        <div>
            {/* Para usuarios nuevos, mostrar SOLO la sección de prestar servicio */}
            {esUsuarioNuevo ? (
                <div className="space-y-9">
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="max-w-4xl mx-auto text-center">
                            <div className="w-20 h-20 mx-auto mb-6 bg-[#1f94c2ff] rounded-full flex items-center justify-center">
                                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                </svg>
                            </div>
                            <div className="mb-8">
                                <div className="inline-block px-4 py-2 bg-blue-50 text-[#1f94c2ff] text-sm font-semibold rounded-full mb-4">
                                    ⭐ Primer paso
                                </div>
                                <h2 className="text-2xl md:text-3xl font-bold text-[#70706eff] mb-3 normal-case">
                                    ¡Te damos la bienvenida a REDPLIKA!
                                </h2>
                                <p className="text-base text-[#6e787aff]">
                                    Ya haces parte de nuestra comunidad. Ahora elige cómo quieres comenzar.
                                </p>
                            </div>

                            <h3 className="text-lg font-semibold text-[#70706eff] mb-6">
                                ¿Cómo quieres participar en la Comunidad?
                            </h3>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mx-auto mb-6 text-left">
                                <button
                                    type="button"
                                    onClick={() => setWelcomeChoice('asistencial')}
                                    className={`rounded-lg border p-4 text-sm text-gray-700 text-left transition-all ${
                                        welcomeChoice === 'asistencial'
                                            ? 'border-[#1f94c2] bg-blue-50 ring-2 ring-[#1f94c2]/40'
                                            : 'border-[#1f94c2]/30 bg-blue-50/60 hover:border-[#1f94c2]'
                                    }`}
                                >
                                    <p className="font-semibold text-[#205087] mb-2">🩺 Ofrecer servicios de salud por telemedicina</p>
                                    <p>Atender pacientes a través de REDPLIKA. Validaremos tu información y documentación profesional.</p>
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setWelcomeChoice('experto')}
                                    className={`rounded-lg border p-4 text-sm text-gray-700 text-left transition-all ${
                                        welcomeChoice === 'experto'
                                            ? 'border-orange-400 bg-orange-50 ring-2 ring-orange-300/70'
                                            : 'border-orange-300/60 bg-orange-50/50 hover:border-orange-400'
                                    }`}
                                >
                                    <p className="font-semibold text-orange-800 mb-2">💡 Compartir mi experiencia y ofrecer otros servicios</p>
                                    <p>Participa en la comunidad, ofrece cursos, asesorías u otros servicios a través de REDPLIKAPLACE.</p>
                                </button>
                            </div>

                            <p className="text-sm text-[#6e787aff] mb-6">
                                Tu elección no es definitiva. Podrás activar nuevas opciones más adelante.
                            </p>

                            <button
                                type="button"
                                disabled={!welcomeChoice}
                                onClick={() => {
                                    if (!welcomeChoice) return;
                                    setProfileRoute(welcomeChoice);
                                    setShowCompleteProfile(true);
                                }}
                                className={`px-8 py-3 text-base font-medium rounded-md transition-colors ${
                                    welcomeChoice
                                        ? 'bg-[#1f94c2ff] text-white hover:bg-[#3090b3ff]'
                                        : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                }`}
                            >
                                Continuar →
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    {/* Solo mostrar las pestañas si el doctor ya ha activado prestar servicio o está aprobado */}
                    <div className="w-full mb-6">
                        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                            <nav className="flex border-b border-gray-200" aria-label="Tabs">
                                <button
                                    onClick={() => setActiveTab('doctor')}
                                    className={`flex-1 px-6 py-4 text-center font-semibold text-base transition-all duration-200 relative ${
                                        activeTab === 'doctor' 
                                            ? 'text-[#205087ff] border-b-2 border-[#205087ff]' 
                                            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                                    }`}
                                >
                                    <div className="flex items-center justify-center gap-2">
                                        <svg className={`w-5 h-5 ${activeTab === 'doctor' ? 'text-[#205087ff]' : 'text-gray-500'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                        </svg>
                                        <span>Perfil Profesional</span>
                                        {activeTab === 'doctor' && (
                                            <span className="ml-1 inline-flex items-center px-2 py-0.5 bg-[#205087ff] text-white text-xs font-bold rounded-full">
                                                Activo
                                            </span>
                                        )}
                                    </div>
                                </button>

                                <button
                                    onClick={handlePatientTabClick}
                                    className={`flex-1 px-6 py-4 text-center font-semibold text-base transition-all duration-200 relative ${
                                        activeTab === 'patient' 
                                            ? 'text-[#205087ff] border-b-2 border-[#205087ff]' 
                                            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                                    } ${doctor.estado === 'no_aprobado' ? 'opacity-60 cursor-not-allowed' : ''}`}
                                    title={doctor.estado === 'no_aprobado' ? 'Completa tu perfil de doctor primero' : ''}
                                    disabled={doctor.estado === 'no_aprobado'}
                                >
                                    <div className="flex items-center justify-center gap-2">
                                        <svg className={`w-5 h-5 ${activeTab === 'patient' ? 'text-[#205087ff]' : 'text-gray-500'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                        </svg>
                                        <span>Perfil Paciente</span>
                                        {activeTab === 'patient' && (
                                            <span className="ml-1 inline-flex items-center px-2 py-0.5 bg-[#205087ff] text-white text-xs font-bold rounded-full">
                                                Activo
                                            </span>
                                        )}
                                    </div>
                                </button>
                            </nav>
                        </div>
                    </div>

                    {activeTab === 'doctor' ? (
                        <div className="space-y-6">
                            {puedeActivarPrestacionServicios && (
                                <div className="bg-gradient-to-r from-blue-50 to-cyan-50 border-l-4 border-[#1f94c2ff] rounded-lg p-5 shadow-sm">
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                                        <div className="flex-1">
                                            <h3 className="text-lg font-semibold text-[#205087] mb-2">
                                                ¿Deseas prestar servicios clínicos?
                                            </h3>
                                            <p className="text-sm text-gray-700">
                                                Puedes activar la atención de pacientes completando el perfil profesional completo.
                                                {doctor.estado === 'en_revision' && (
                                                    <> Tu perfil actual sigue en revisión; al enviar el perfil clínico iniciarás esa ruta.</>
                                                )}
                                            </p>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={iniciarPrestacionServicios}
                                            className="shrink-0 px-5 py-2.5 bg-[#205087] hover:bg-[#1a3d6b] text-white font-medium rounded-md transition-colors"
                                        >
                                            Activar prestación de servicios
                                        </button>
                                    </div>
                                </div>
                            )}
                            {!membershipLoading && isPremiumDoctor && (
                                <div className={`rounded-2xl border shadow-sm overflow-hidden ${hasPremiumContractSigned ? 'border-emerald-200 bg-emerald-50/60' : 'border-amber-200 bg-amber-50/70'}`}>
                                    <div className={`px-5 py-4 border-b ${hasPremiumContractSigned ? 'bg-emerald-100/70 border-emerald-200' : 'bg-amber-100/80 border-amber-200'}`}>
                                        <h3 className={`text-lg font-semibold flex items-center gap-2 ${hasPremiumContractSigned ? 'text-emerald-800' : 'text-amber-900'}`}>
                                            <span className="text-xl">📄</span>
                                            Contrato de vinculación - Plan Miembro Premium
                                        </h3>
                                        <p className={`text-sm mt-1 ${hasPremiumContractSigned ? 'text-emerald-700' : 'text-amber-800'}`}>
                                            {hasPremiumContractSigned
                                                ? 'Tu contrato premium ya fue firmado y quedó almacenado en el sistema.'
                                                : 'Debes firmar este contrato premium para dejar completa tu vinculación como profesional premium.'}
                                        </p>
                                    </div>
                                    <div className="px-5 py-4 flex flex-wrap items-center gap-3">
                                        {hasPremiumContractSigned ? (
                                            <>
                                                <span className="text-sm text-slate-700">
                                                    Firmado el {doctor.fechaFirmaContratoVinculacionPremium
                                                        ? new Date(doctor.fechaFirmaContratoVinculacionPremium).toLocaleString('es-CO', { dateStyle: 'medium', timeStyle: 'short' })
                                                        : '—'}
                                                </span>
                                                <a
                                                    href={doctor.urlContratoVinculacionPremiumFirmado}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="inline-flex items-center px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-sm font-medium transition-colors"
                                                >
                                                    Ver PDF firmado
                                                </a>
                                            </>
                                        ) : (
                                            <button
                                                type="button"
                                                onClick={() => setShowPremiumContractModal(true)}
                                                className="inline-flex items-center px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white rounded-lg text-sm font-medium transition-colors"
                                            >
                                                Abrir y firmar contrato premium
                                            </button>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Banner: configurar ePayco cuando documentos aprobados */}
                            {doctor.estado === 'pendiente_epayco' && (
                                <div className="bg-gradient-to-r from-blue-50 to-sky-50 border-l-4 border-[#1f94c2] rounded-lg p-4 shadow-sm mb-4">
                                    <div className="flex items-start">
                                        <div className="flex-shrink-0">
                                            <svg className="h-6 w-6 text-[#1f94c2]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                        </div>
                                        <div className="ml-3 flex-1">
                                            <h3 className="text-lg font-semibold text-[#205087] mb-2">
                                                Siguiente paso: configura tu pago ePayco
                                            </h3>
                                            <p className="text-sm text-gray-700 mb-4">
                                                Tus documentos fueron aprobados. Crea tu cuenta ePayco y guarda tu Account ID en Configuración de citas para que el equipo confirme tu registro y habilite tarifas y agenda.
                                            </p>
                                            <button
                                                type="button"
                                                onClick={() => { window.location.href = '/doctor/configuracion-citas'; }}
                                                className="inline-flex items-center px-4 py-2 bg-[#1f94c2] hover:bg-[#205087] text-white font-medium rounded-md transition-colors"
                                            >
                                                Ir a Configuración de citas
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Alerta horarios: solo perfil asistencial (Sí a servicios clínicos) */}
                            {!verificandoHorarios &&
                                doctor.estado === 'aprobado' &&
                                doctor.tipoPerfil !== 'experto' &&
                                doctor.prestacionServicio !== false &&
                                !tieneHorariosConfigurados && (
                                <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border-l-4 border-yellow-400 rounded-lg p-4 shadow-sm">
                                    <div className="flex items-start">
                                        <div className="flex-shrink-0">
                                            <svg className="h-6 w-6 text-yellow-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                            </svg>
                                        </div>
                                        <div className="ml-3 flex-1">
                                            <h3 className="text-lg font-semibold text-yellow-800 mb-2">
                                                ⚠️ Configura tus Horarios de Disponibilidad
                                            </h3>
                                            <p className="text-sm text-yellow-700 mb-4">
                                                Tu perfil está aprobado. Para que los pacientes puedan agendar citas contigo, 
                                                necesitas configurar tus horarios de disponibilidad.
                                            </p>
                                            <button
                                                onClick={() => window.location.href = '/doctor/configuracion-citas'}
                                                className="inline-flex items-center px-4 py-2 bg-yellow-600 hover:bg-yellow-700 text-white font-medium rounded-md transition-colors duration-200"
                                            >
                                                Configurar Horarios de Citas
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                            
                            <UserProfile
                                afiliadoEstado={doctor.estado}
                                isAfiliadoPrestarServicio={doctor.prestacionServicio}
                                tipoPerfil="Perfil del miembro"
                                userImage={doctor.urlProfessionalPhoto}
                                textareas={textareasDoctor}
                                inputs={inputsDoctor}
                                onEdit={onEditCancel}
                                onGuardar={onHandleActualizarPerfil}
                                onCancelar={onEditCancel}
                                setShowCompleteProfile={() => {
                                    setProfileRoute('asistencial');
                                    setShowCompleteProfile(true);
                                }}
                                onPhotoChange={(croppedFile) => {
                                    console.log('onPhotoChange llamado con:', croppedFile);
                                    if (croppedFile) {
                                        setFile(prevFile => {
                                            const newFile = { ...prevFile, foto_perfil: croppedFile };
                                            console.log('Estado file actualizado:', newFile);
                                            return newFile;
                                        });
                                    }
                                }}
                            />


                            {doctor.estado !== 'no_aprobado' && (
                                <>
                                    {/* Inicio componente de documentos */}
                                    <TableDocuments
                                        lstDocuments={documentsExists ? documentsExists : []}
                                        filesToEdit={file}
                                        setFilesToEdit={setFile}
                                        showGuardarCambios={hasDocumentosParaGuardar}
                                        onClickGuardarCambios={onGuardarDocumentosAlmacenados}
                                        doctorEstado={doctor.estado}
                                    />
                                </>
                            )}

                            <RedesSociales
                                redesSociales={doctor?.socialMedia}
                                isPatient={false}
                                userId={doctor._id}
                            />
                        </div>
                    ) : showRestrictionMessage ? (
                        <div className="flex flex-col items-center justify-center py-12 px-4">
                            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg shadow-md w-full max-w-2xl">
                                <div className="flex items-start">
                                    <div className="flex-shrink-0">
                                        <svg className="h-6 w-6 text-yellow-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                        </svg>
                                    </div>
                                    <div className="ml-3 flex-1">
                                        <h3 className="text-lg font-semibold text-yellow-800 mb-2">
                                            Acceso Restringido
                                        </h3>
                                        <p className="text-sm text-yellow-700 mb-4">
                                            No puedes acceder al perfil de usuario hasta completar tu perfil profesional. 
                                            Completa todos los datos requeridos en el perfil de miembro antes de continuar.
                                        </p>
                                        <button
                                            onClick={() => {
                                                setActiveTab('doctor');
                                                setShowRestrictionMessage(false);
                                                setShowCompleteProfile(true);
                                            }}
                                            className="inline-flex items-center px-4 py-2 bg-yellow-600 hover:bg-yellow-700 text-white font-medium rounded-md transition-colors duration-200"
                                        >
                                            Completar Perfil Profesional
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <PatientProfile />
                    )}
                </>
            )}

            {/* Modal de confirmación de foto */}
            <Modal
                isOpen={showConfirmPhotoModal}
                onRequestClose={() => {
                    setShowConfirmPhotoModal(false);
                    setFile(prevFile => ({ ...prevFile, foto_perfil: null }));
                }}
                className="w-[90%] max-w-md mx-auto bg-white p-6 rounded-lg shadow-lg border border-gray-200 focus:outline-none"
                overlayClassName="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100]"
            >
                <div className="text-center">
                    <h2 className="text-xl font-semibold text-[#205087ff] mb-4">
                        Confirmar Foto de Perfil
                    </h2>
                    
                    {previewPhoto && (
                        <div className="mb-6 flex justify-center">
                            <div className="relative">
                                <img
                                    src={previewPhoto}
                                    alt="Vista previa de foto de perfil"
                                    className="w-48 h-48 rounded-full object-cover border-4 border-[#1f94c2ff] shadow-md"
                                />
                            </div>
                        </div>
                    )}
                    
                    <p className="text-sm text-gray-600 mb-6">
                        ¿Deseas guardar esta foto como tu foto de perfil?
                    </p>
                    
                    <div className="flex gap-3 justify-center">
                        <button
                            type="button"
                            onClick={() => {
                                setShowConfirmPhotoModal(false);
                                setFile(prevFile => ({ ...prevFile, foto_perfil: null }));
                            }}
                            className="px-6 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium rounded transition-colors duration-200"
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                console.log('Confirmar foto - file.foto_perfil:', file?.foto_perfil);
                                onHandleSubmitFiles();
                                setShowConfirmPhotoModal(false);
                            }}
                            className="px-6 py-2.5 bg-[#1f94c2ff] hover:bg-[#205087ff] text-white font-medium rounded transition-colors duration-200"
                        >
                            Confirmar
                        </button>
                    </div>
                </div>
            </Modal>

            <SignatureHelpModal
                isOpen={showFirmaInstruccionesModal}
                onClose={() => setShowFirmaInstruccionesModal(false)}
                title="¿Cómo firmar el contrato?"
            />

            <Modal
                isOpen={showPremiumContractModal}
                onRequestClose={() => setShowPremiumContractModal(false)}
                className="w-[95%] max-w-4xl mx-auto bg-white rounded-lg shadow-xl border border-gray-200 focus:outline-none max-h-[95vh] flex flex-col"
                overlayClassName="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-[120] p-4"
            >
                <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-[#1f94c2ff] text-white rounded-t-lg">
                    <h3 className="text-lg font-semibold">Contrato de vinculación - Plan Miembro Premium</h3>
                    <button
                        type="button"
                        onClick={() => setShowPremiumContractModal(false)}
                        className="p-1 rounded hover:bg-white/20 text-white"
                        aria-label="Cerrar"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div className="flex-1 overflow-y-auto p-4 space-y-4">
                    <p className="text-sm text-gray-600">
                        Lee el documento completo. Al final, firma digitalmente para aceptar el contrato premium.
                    </p>
                    <div className="border border-gray-300 rounded-md overflow-y-auto bg-white p-6" style={{ maxHeight: '50vh', minHeight: 400 }}>
                        <ContratoVinculacionPlanMiembroPremium />
                    </div>
                    <div className="pt-4 border-t-2 border-[#1f94c2ff]">
                        <p className="text-sm font-semibold text-[#205087ff] mb-2">Datos del firmante</p>
                        <p className="text-sm text-gray-600 mb-3">
                            Ingresa tus datos tal como deben aparecer en el contrato.
                        </p>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
                            <div className="md:col-span-2">
                                <label className="block text-xs font-medium text-gray-600 mb-1">Nombre completo *</label>
                                <input
                                    type="text"
                                    value={premiumContractModalNombre}
                                    onChange={(e) => setPremiumContractModalNombre(e.target.value)}
                                    className="w-full px-3 py-2 border border-[#9e9e9dff] rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#1f94c2ff]"
                                    placeholder="Nombre completo"
                                />
                            </div>
                            <div>
                                <label className="block text-xs font-medium text-gray-600 mb-1">Tipo de documento *</label>
                                <select
                                    value={premiumContractModalIdType}
                                    onChange={(e) => setPremiumContractModalIdType(e.target.value)}
                                    className="w-full px-3 py-2 border border-[#9e9e9dff] rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#1f94c2ff]"
                                >
                                    <option value="">Selecciona</option>
                                    <option value="CC">CC</option>
                                    <option value="TI">TI</option>
                                    <option value="CE">CE</option>
                                    <option value="PS">PS</option>
                                    <option value="DE">DE</option>
                                </select>
                            </div>
                            <div>
                                <label className="block text-xs font-medium text-gray-600 mb-1">Número de identificación *</label>
                                <input
                                    type="text"
                                    value={premiumContractModalIdNumber}
                                    onChange={(e) => setPremiumContractModalIdNumber(e.target.value)}
                                    className="w-full px-3 py-2 border border-[#9e9e9dff] rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#1f94c2ff]"
                                    placeholder="Número"
                                />
                            </div>
                        </div>
                        <p className="text-sm font-semibold text-[#205087ff] mb-2">Firma digital</p>
                        <SignatureInstructionsPanel title="¿Cómo firmar el contrato?" />
                        <p className="text-xs text-gray-500 mb-3 text-center">
                            Dibuja tu firma en el recuadro usando el mouse o tu dedo
                        </p>
                        <div ref={signatureContainerRefPremiumContrato} className="border-2 border-[#9e9e9dff] rounded-md bg-white w-full overflow-hidden" style={{ touchAction: 'none' }}>
                            <SignatureCanvas
                                ref={sigCanvasRefPremiumContrato}
                                canvasProps={{
                                    className: 'rounded-md block',
                                    width: signatureCanvasSizePremiumContrato.width,
                                    height: signatureCanvasSizePremiumContrato.height,
                                    style: { width: '100%', height: signatureCanvasSizePremiumContrato.height, display: 'block' }
                                }}
                                penColor="black"
                                backgroundColor="rgb(255, 255, 255)"
                                clearOnResize={false}
                            />
                        </div>
                        <div className="flex flex-wrap gap-2 mt-3">
                            <button
                                type="button"
                                onClick={() => sigCanvasRefPremiumContrato.current?.clear()}
                                className="px-3 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 text-sm"
                            >
                                Limpiar firma
                            </button>
                            <button
                                type="button"
                                onClick={handleFirmarContratoPremium}
                                disabled={premiumContractSigning}
                                className="px-4 py-2 bg-[#1f94c2ff] text-white rounded-md hover:bg-[#205087ff] disabled:opacity-50 text-sm font-medium"
                            >
                                {premiumContractSigning ? 'Guardando...' : 'Firmar contrato'}
                            </button>
                            <button
                                type="button"
                                onClick={() => setShowPremiumContractModal(false)}
                                className="px-3 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 text-sm"
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>

    ) : showCompleteProfile ?
        (
            profileRoute === 'experto' ? (
                <CompleteProfileExpert
                    doctor={doctor}
                    setDoctor={setDoctor}
                    setShow={(value) => {
                        setShowCompleteProfile(value);
                        if (!value) setProfileRoute(null);
                    }}
                />
            ) : (
                <CompleterProfileDoctor
                    doctor={doctor}
                    setDoctor={setDoctor}
                    setShow={(value) => {
                        setShowCompleteProfile(value);
                        if (!value) setProfileRoute(null);
                    }}
                />
            )
        )
        : (
            <ReenvioDocumentos doctor={doctor} setShow={setShowReenvioDocumentos} />
        )
};

export default DoctorInfo;